module.exports = __webpack_public_path__ + "static/media/back.38a10309.jpg";